<template lang="html">
  <div>
    <el-table
      :data="datas"
      style="width: 100%">
      <el-table-column
        prop="orderNumber"
        label="订单编号">
      </el-table-column>
      <el-table-column
        label="订单内容">
        <template scope="scope">
          <el-popover trigger="hover" placement="top">
            <p style="width:200px">
              <b> {{ scope.row.goodsName }}</b>
              </br>
               {{ scope.row.goodsDesc }}
            </p>
            <div slot="reference" class="name-wrapper">
              <el-tag size="medium">{{ scope.row.goodsName }}</el-tag>
            </div>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column
        prop="buyerName"
        label="下单人">
        <template  scope="scope">
          <span>{{scope.row.buyerName}} - {{scope.row.buyerPhone}}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="下单时间">
        <template  scope="scope">
          <span>{{scope.row.createTime | dateTimeFormat}}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="amount"
        label="支付金额（元）">
      </el-table-column>
      <el-table-column
        label="支付状态">
        <template  scope="scope">
          <span>{{scope.row.payState | orderFilter}}</span>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="basic-margin"
      current-page.sync="pageNum"
      @current-change="changePage"
      layout="total, prev, pager, next"
      :page-size="pageSize"
      :total="total">
    </el-pagination>
  </div>

</template>

<script>
import ChannelModel from '@/framework/models/channelModel'
import BasicPager from '@/mixins/BasicPager'
export default {
  extends: BasicPager,
  data: function () {
    return {
      pageSize: 10,
      total: 0,
      pageNum: 1,
      datas: []
    }
  },
  created: function () {
    this.loadList()
  },
  methods: {
    changePage: function (pageNum) {
      this.pageNum = pageNum
      this.loadList()
    },
    loadList: function () {
      // 不是渠道用户
      if (this.loginInfo.loginPath != 'channel') {
        return
      }

      // 查询订单列表
      let _this = this
      let params = {
        channelId: _this.loginInfo.id,
        pageSize: _this.pageSize,
        pageNum: _this.pageNum
      }

      let listener = {
        success: function (dataInfo) {
          _this.datas = dataInfo.data
          _this.total = dataInfo.recordsTotal
        }
      }

      ChannelModel.findOrderList(_this, params, listener)
    }
  }
}
</script>

<style lang="css">
</style>
